(() => {
if(window.c2relatedCarouselReady)return;
window.c2relatedCarouselReady=true;
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-c2related-step]');
 if(!button)return;
 const track=button.closest('[data-c2related-carousel]').querySelector('.c2related-grid');
 if(!track?.children.length)return;
 const direction=Number(button.dataset.c2relatedStep);
 const step=track.children[0].getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
 const end=track.scrollWidth-track.clientWidth;
 let left=track.scrollLeft+step*direction;
 if(direction>0&&track.scrollLeft>=end-3)left=0;
 if(direction<0&&track.scrollLeft<=3)left=end;
 track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
});
})();
